import React, { useState } from 'react';
import { UploadIcon } from 'lucide-react';
import { uploadMedia } from '../../../services/campersServices';

// Uploads eagerly on file-select (matches the legacy medicalDocument behavior) and stores
// only the resulting URL string as the answer — the raw file never travels with form submit.
// Removing clears to '' rather than undefined: undefined is dropped from the submitted
// answers, and since answer rows are upserted the removal would never reach the backend.
const FileUploadField = ({ value, onChange }) => {
    const [uploading, setUploading] = useState(false);

    const handleUpload = e => {
        const file = e.target.files[0];
        if (!file) return;
        setUploading(true);
        const data = new FormData();
        data.append('file', file);
        uploadMedia(data).then(res => {
            setUploading(false);
            if (res.data.responseData.result.fileUrl !== undefined) {
                onChange(res.data.responseData.result.fileUrl);
            }
        }).catch(() => setUploading(false));
    };

    const filename = typeof value === 'string' && value ? value.slice(value.lastIndexOf('_') + 1) : '';

    return (
        <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-3 tw-rounded-xl tw-border tw-border-dashed tw-border-sand-300 tw-bg-white tw-p-4">
            <label className="tw-inline-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-lg tw-border tw-border-brand-600 tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-brand-700 tw-transition hover:tw-bg-brand-50">
                <UploadIcon className="tw-h-4 tw-w-4" aria-hidden="true" />
                {uploading ? 'Uploading…' : 'Attach PDF'}
                <input type="file" className="tw-hidden" value="" accept="application/pdf" onChange={handleUpload} />
            </label>
            <span className="tw-text-xs tw-text-gray-500">{filename || (value ? value : 'PDF up to 10 MB')}</span>
            {value ? (
                <button type="button" onClick={() => onChange('')} className="tw-text-xs tw-font-semibold tw-text-brand-600 hover:tw-text-brand-800">
                    Remove
                </button>
            ) : null}
        </div>
    );
};

export default FileUploadField;
